import scss from "./Empty.module.scss";
import { useTranslation } from "react-i18next";

/**
 * Show that some data is emty.
 *
 * @param {?string} message The message to show, or null to show the default one.
 *
 * @return {JSX.Element}
 * @constructor
 */
const Empty = ({ message = null, search, orders }) => {
    const { t } = useTranslation();
    return (
        <div className={scss.wrapper}>
            {search?.length !== 0 && orders?.length === 0 ? (
                <>{t("global-message-no_data_for_requested_criteria", { search: search ? search : "" })}</>
            ) : (
                <>{message ? t(message) : t("global-message-no_data_to_show")}</>
            )}
        </div>
    );
};

export default Empty;
